import closeAllMenus from '../core/INF-closeAllMenus';

const SiteOverlay = () => {
  document.addEventListener('click', (e) => {
    const target = e.target.closest('[data-site-overlay]');
    if (target) {
      closeAllMenus();
      window.dispatchEvent(new Event('scroll'));
    }
  });
};

export { SiteOverlay };
